import React from "react";
import { useHistory } from "react-router-dom";

import { navigateStack } from "utils/WeChatUtil";
import { CouponIcon, MyCardIcon, TicketIcon } from "component/base/SvgIcons";
import i18n from "utils/I18n";

import "./MyCouponsMobileSection.scss"

export const MyTicketsMobileSection = () => {
  const history = useHistory();

  const handleClick = () => {
    navigateStack({ pathname: "/user/myTicket", history })
  }
  return (
    <>
      <div className="home-level-benefit-section mobile-my-coupons-section d-flex" onClick={handleClick}>
        <div className="common-profile-section-text color-p2 subheading">
          <TicketIcon />
          {i18n.t("myTicket")}
        </div>
      </div>
    </>
  );
}

export const MyCardMobileSection = () => {
  const history = useHistory();

  const handleClick = () => {
    navigateStack({ pathname: "/user/myCard", history })
  }
  return (
    <>
      <div className="home-level-benefit-section mobile-my-coupons-section d-flex" onClick={handleClick}>
        <div className="common-profile-section-text color-p2 subheading">
          <MyCardIcon />
          {i18n.t("my_card")}
        </div>
      </div>
    </>
  );
}

const MyCouponsMobileSection = () => {
  const history = useHistory();

  const handleClick = () => {
    navigateStack({ pathname: "/user/myCoupon", history })
  }
  return (
    <>
      <div className="home-level-benefit-section mobile-my-coupons-section d-flex" onClick={handleClick}>
        <div className="common-profile-section-text color-p2 subheading">
          <CouponIcon />
          {i18n.t("profile_my_coupons")}
        </div>
      </div>
    </>
  );
}


export default MyCouponsMobileSection;
